import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Upload,
  Table,
  Typography,
  message,
  Select,
  Row,
  Col,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBasePath } from "../../../components/NavigatePath";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector } from "react-redux";
import UploadProfilePicture from "../../../components/UploadProfilePicture";
function AddBranch() {
  const [form] = Form.useForm();
  const location = useLocation();
  const data = location.state?.data;
  const basePath = useBasePath();
  const hasRedirected = useRef(false);
  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [citiesList, setCitiesList] = useState([]);

  const fetchCities = async () => {
    try {
      const response = await axios.get(`${API_URL}userProfiles/get-cities`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const citiesList = response.data.Cities.map((city) => ({
        id: city.id,
        name: city.name,
      }));
      setCitiesList(citiesList);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };
  useEffect(() => {
    fetchCities();
  }, []);
  useEffect(() => {
    if (data === undefined && !hasRedirected.current) {
      message.error("Data not found.");
      hasRedirected.current = true;
      navigate(`/${basePath}/pharmacies`);
    }
  }, [data, navigate, basePath]);

  //Track edit
  const [isEditMode, setIsEditMode] = useState(false);
  const [status, setStatus] = useState(data?.active ? "Active" : "Inactive");

  const onFinish = async (value) => {
    const payload = {
      name: value.Branch_Name,
      startDate: value.startDate_branch.toISOString(),
      endDate: value.endDate_branch.toISOString(),
      PharmacyID: data.id,
      address: {
        cityID: value.city,
        district: value.district,
        street: value.street,
        floor: value.floor,
        apartment: value.apartment,
      },
    };
    console.log("payload ", payload);
    try {
      const response = await axios.post(`${API_URL}Branches`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log(response);
      message.success(" Add branch.");
      navigate(-1);
      form.resetFields();
    } catch (error) {
      console.error("Error saving branch:", error);
      message.error(`${error.response.data.message}`);
    }
  };
  const CancelButton = () => {
    navigate(-1);
    form.resetFields();
  };
  const uploadButton = (
    <div>
      <PlusOutlined />
    </div>
  );

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        style={{ width: "100%" }}
        initialValues={{
          start_date: dayjs(data?.startDate),
          end_date: dayjs(data?.endDate),
          Admin_contact: data?.adminDetails?.mobileNumber,
          Pharmacy_Admin:
            data?.adminDetails?.userDetails?.firstName +
            " " +
            data?.adminDetails?.userDetails?.lastName,
        }}
        onFinish={onFinish}
      >
        <div className="flex flex-row items-center font-semibold mb-4 text-lg md:text-xl lg:text-2xl">
          Profile -
          <span className="font-normal ml-2 md:ml-4">
            {data ? data.name : null}
          </span>
        </div>

        <div className="flex flex-col bg-white p-4 md:p-6 lg:p-10 rounded-sm">
          <Row gutter={[16, 16]} className="w-full">
            <Col xs={24} sm={24} md={6} lg={5} xl={4} className="flex flex-col items-center space-y-4 md:space-y-6">
              <UploadProfilePicture
                disabled={!isEditMode}
                value={data.logo ? data.logo : imageUrl}
              // onChange={(url) => {
              //     setImageUrl(url);
              // }}
              />

              <div className="flex flex-row items-center space-x-2 md:space-x-4">
                <img src="/assets/images/phone-call.svg" alt="" className="w-5 h-5" />
                <p className="text-base md:text-lg lg:text-xl">{data ? data.contactNumber : null}</p>
              </div>
            </Col>

            <Col xs={24} sm={24} md={18} lg={19} xl={20}>
              <div className="flex flex-col space-y-3 md:space-y-5">
                <div className="flex flex-row items-center space-x-2">
                  <p className="text-sm md:text-base">Activity status</p>
                  <div
                    className={`p-1 md:p-2 ${status === "Active"
                        ? "bg-[#E8FAE9] text-[#14CC26]"
                        : "bg-[#F8D7DA] text-[#FF0000]"
                      }`}
                  >
                    <p>{status}</p>
                  </div>
                </div>

                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract Start Date
                        </span>
                      }
                      name="start_date"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract Start Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Contract End Date
                        </span>
                      }
                      name="end_date"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Contract End Date",
                        },
                      ]}
                    >
                      <DatePicker
                        prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                        suffixIcon={null}
                        placeholder=""
                        style={{ width: "100%" }}
                        className="h-9 md:h-10"
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Pharmacy Admin
                        </span>
                      }
                      name="Pharmacy_Admin"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Pharmacy Admin",
                        },
                      ]}
                    >
                      <Input
                        disabled={!isEditMode}
                        className="h-9 md:h-10"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label={
                        <span className="text-sm md:text-base font-medium">
                          Admin Contact Number
                        </span>
                      }
                      name="Admin_contact"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter a Admin Contact Number",
                        },
                      ]}
                    >
                      <Input
                        className="no-arrows h-9 md:h-10"
                        style={{ width: "100%" }}
                        disabled={!isEditMode}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <div className="mt-2 md:mt-4">
                  <p className="text-lg md:text-xl font-semibold">
                    Add Branches
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          <div className="w-full mt-6 md:mt-8 lg:mt-12">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} lg={8}>
                <Form.Item
                  label={
                    <span className="text-sm md:text-base font-medium">
                      Branch Name
                    </span>
                  }
                  name="Branch_Name"
                  rules={[
                    { required: true, message: "Please Enter a Branch Name" },
                    {
                      whitespace: true,
                      message: "No white Space",
                    },
                  ]}
                >
                  <Input className="h-9 md:h-10" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span className="text-sm md:text-base font-medium">
                      Start Date
                    </span>
                  }
                  name="startDate_branch"
                  rules={[
                    { required: true, message: "Please Enter a Start Date" },
                  ]}
                >
                  <DatePicker
                    prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                    suffixIcon={null}
                    placeholder=""
                    style={{ width: "100%" }}
                    className="h-9 md:h-10"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  label={
                    <span className="text-sm md:text-base font-medium">
                      End Date
                    </span>
                  }
                  name="endDate_branch"
                  rules={[
                    { required: true, message: "Please Enter a End Date" },
                  ]}
                >
                  <DatePicker
                    prefix={<img src="/assets/images/date.svg" alt="calendar icon" />}
                    suffixIcon={null}
                    placeholder=""
                    style={{ width: "100%" }}
                    className="h-9 md:h-10"
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="border-[2px] p-3 md:p-5 rounded mt-4">
              <div className="mb-3 md:mb-4">
                <p className="text-base md:text-lg lg:text-xl font-medium">
                  Address
                </p>
              </div>

              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={
                      <span className="text-sm md:text-base font-medium">
                        City
                      </span>
                    }
                    name="city"
                    rules={[{ required: true, message: "Please Enter a City" }]}
                  >
                    <Select className="h-9 md:h-10">
                      {citiesList.map((city) => {
                        return <Option key={city.id}>{city.name}</Option>;
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={
                      <span className="text-sm md:text-base font-medium">
                        District
                      </span>
                    }
                    name="district"
                    rules={[
                      { required: true, message: "Please Enter a District" },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input className="h-9 md:h-10" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Form.Item
                    label={
                      <span className="text-sm md:text-base font-medium">
                        Street
                      </span>
                    }
                    name="street"
                    rules={[
                      { required: true, message: "Please Enter a Street" },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input className="h-9 md:h-10" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={
                      <span className="text-sm md:text-base font-medium">
                        Floor
                      </span>
                    }
                    name="floor"
                    rules={[
                      { required: true, message: "Please Enter a Floor" },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input className="h-9 md:h-10" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={
                      <span className="text-sm md:text-base font-medium">
                        Apartment
                      </span>
                    }
                    name="apartment"
                    rules={[
                      { required: true, message: "Please Enter a Apartment" },
                      {
                        whitespace: true,
                        message: "No white Space",
                      },
                    ]}
                  >
                    <Input className="h-9 md:h-10" />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="flex flex-col sm:flex-row justify-between mt-6 gap-4">
              <Button
                type=""
                onClick={CancelButton}
                className="order-2 sm:order-1 py-2 px-4 md:py-3 md:px-6 lg:py-4 lg:px-10 text-sm lg:text-base"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="order-1 sm:order-2 py-2 px-4 md:py-3 md:px-6 lg:py-4 lg:px-10 text-sm lg:text-base"
              >
                Add Branch
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default AddBranch;
